module.exports = __webpack_public_path__ + "img/WhatsApp-2.f3d37082.jpeg";